import { useLoggedViewer } from "@/api/viewer/use-viewer";
import { TextDto } from "@babackapp/private-api-client/types";

export default function useTextDtoValue(values?: TextDto[] | null) {
  const { data: viewer } = useLoggedViewer();

  const map = (values ?? []).reduce(
    (acc, value) => {
      return { ...acc, [value.lang]: value.text };
    },
    {} as Record<string, string>,
  );

  const label =
    (viewer?.profile?.lang ? map[viewer.profile.lang] : undefined) ??
    map[Object.keys(map)[0]];

  return label ?? "-";
}
